<template>
  <div :class="{formGroup: true, isRequired: itemSetting.action.isRequired, isSubOption: isSubOption}">
    <span class="idStkr">
      {{isSubOption ? `${isSubOption.parentLabel}:${isSubOption.parentValue} > ` : ''}}{{itemSetting.action.labelValue}}
    </span>
    <div class="label" :style="labelStyle">{{itemSetting.action.label[activeLang]}}</div>
    <input type="text" class="input" :style="valueStyle">
  </div>
</template>

<script>
export default {
  name: 'InputModule',
  props: [
    'locale',
    'activeLang',
    'isNew',
    'hasPrice',
    'id',
    'moduleIndex',
    'item',
    'itemSetting',
    'subOption'
  ],
  computed: {
    isSubOption () {
      const id = this.id
      return this.subOption.find(x => x.child === id)
    },
    labelStyle () {
      const fontSize = this.itemSetting.action.labelFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    },
    valueStyle () {
      const fontSize = this.itemSetting.action.valueFontSize
      return {
        ...fontSize && fontSize !== 'default' && {
          fontSize: `${fontSize}px`
        }
      }
    }
  },
  methods: {
  }
}
</script>
